import { useEffect, useState } from "react";
import Api from "../openapi";
import { MembershipUsersResponse } from "../openapi/client";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { checkEmptyObj } from "../utils";

export default function useMembershipUsers(retriggerReq?: number) {
  const user = useSelector((state: RootState) => state.user);
  const membershipUsersReqTrigger = useSelector((state: RootState) => state.global.membershipUsersReqTrigger);
  const [users, setUsers] = useState<MembershipUsersResponse>();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchMembershipUsers = async () => {
      try {
        setLoading(true);
        const res = await Api.Membership.getUsersOfMembership();
        setUsers(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (!checkEmptyObj(user)) fetchMembershipUsers();
  }, [retriggerReq, user, membershipUsersReqTrigger]);
  return { users, loading };
}
